<template>
    <main class="main">
        <div class="container">
            <bread-crumbs force-default-url default-url="my-business" />

            <sub-section-header :title="`Warunki współpracy - ${$route.params.alias.toUpperCase()}`"/>

            <header-tabs
                class="mb-tabs mt-3 mb-4"
                style="flex: 1"
                :content="headerTabs"
                :active-tab="0"
            />

            <router-view />
        </div>
    </main>
</template>

<script>
import networkMixin from './network.mixin'

export default {
    mixins: [networkMixin],

    async created() {
        if (this.$store.getters.isShopUser) {
            // Load networks and check network permission
            await this.loadNetworksAndCheckPermission()
            return
        }

        if (
            !this.network ||
            this.network.code.toLowerCase() !== this.$route.params.alias
        ) {
            this.$store.commit('RESET_MY_BUSINESS_NETWORKS')

            await this.$store.dispatch('loadMyBusinessNetwork', {
                offset: 0,
                limit: 100,
                section: this.$route.params.alias.toUpperCase()
            })
        }

        this.fetch()
    },

    computed: {
        network() {
            return this.$store.getters.getMyBusinessNetworks[0]
        },

        headerTabs() {
            return this.subsections.map(({ counter, counterTooltip, ...subsection }) => subsection)
        }
    },

    methods: {
        fetch() {
            this.$store.commit('SET_MY_BUSINESS_NEWS', null)
            const { newsId, alias } = this.$route.params
            const params = {
                offset: 0,
                limit: 100,
                section: alias.toUpperCase(),
                newsId
            }

            this.$store.dispatch('loadMyBusinessTerms', {
                params
            })
        }
    }
}
</script>

<styles lang="scss">
.header-tabs {
    &.mb-tabs {
        .nav {
            overflow-y: auto;
        }
    }
}
</styles>
